import { customAlphabet } from "nanoid";

const ALPHANUMERIC = "1234567890abcdefghijklmnopqrstuvwxyz";

const generate = customAlphabet(ALPHANUMERIC, 10);

export const generateReactKey = ({
  prefix = "",
}: { prefix?: string } = {}): string => {
  return prefix + generate();
};
